import { FC, Fragment } from 'react';
import { Area } from './SearchSuggestionsTownsAndCities.types';
import { sectionIcon } from './sectionIcon';
import { Divider } from '@zoopla-eng/zds/divider';
import { Box } from '@zoopla-eng/zds/box';
import { fontGroups } from '@zoopla-eng/zds/themes';
import { ArrowRightSmall } from '@zoopla-eng/zds/icons';
import {
    iconAndHeadingWrapperStyle,
    linkWrapperStyle,
    sectionHeadingStyle,
    sectionIconStyle,
    sectionStyle,
    sectionWrapperStyle,
    styledImageStyle
} from './SearchSuggestionsTownsAndCities.styles.css';
import { Link, LinkWithIcon } from '@zoopla-eng/zds/link';

type TownsAndCitiesLinksProps = {
    areas: Area[];
    trackSeeAll: () => void;
    trackSeeIndividual: (location: string) => void;
};

export const SearchSuggestionTownsAndCityLinks: FC<
    React.PropsWithChildren<TownsAndCitiesLinksProps>
> = ({ areas, trackSeeAll, trackSeeIndividual }) => {
    return (
        <Fragment>
            {areas.map((area, index) => {
                return (
                    <Fragment key={area.id}>
                        <div
                            className={sectionWrapperStyle}
                            data-testid="town-and-city-link-group"
                        >
                            <div className={sectionHeadingStyle}>
                                <div className={sectionIconStyle}>
                                    <img
                                        className={styledImageStyle}
                                        src={sectionIcon(area.id)}
                                        alt=""
                                        loading="lazy"
                                    />
                                </div>
                                <div className={iconAndHeadingWrapperStyle}>
                                    <h3 className={fontGroups.mug}>
                                        {area.headline}
                                    </h3>
                                    <p>{area.sub_headline}</p>
                                    {area.see_all_property && (
                                        <Box py="S400">
                                            <Link
                                                data-testid="towns-and-city-links-see-all"
                                                href={
                                                    area.see_all_property.link
                                                }
                                                onClick={trackSeeAll}
                                            >
                                                {area.see_all_property.text}
                                            </Link>
                                        </Box>
                                    )}
                                </div>
                            </div>
                            <div className={sectionStyle}>
                                {area.items.slice(0, 3).map((item) => {
                                    return (
                                        <Fragment key={item.url}>
                                            <div className={linkWrapperStyle}>
                                                <LinkWithIcon
                                                    iconPrefix={
                                                        <ArrowRightSmall />
                                                    }
                                                    href={item.url}
                                                    data-testid="town-and-city-link"
                                                    onClick={() =>
                                                        trackSeeIndividual(
                                                            item.location
                                                        )
                                                    }
                                                >
                                                    {item.headline}
                                                </LinkWithIcon>
                                            </div>
                                        </Fragment>
                                    );
                                })}
                            </div>
                            <div className={sectionStyle}>
                                {area.items.slice(3, 6).map((item) => {
                                    return (
                                        <Fragment key={item.url}>
                                            <div className={linkWrapperStyle}>
                                                <LinkWithIcon
                                                    iconPrefix={
                                                        <ArrowRightSmall />
                                                    }
                                                    href={item.url}
                                                    onClick={() =>
                                                        trackSeeIndividual(
                                                            item.location
                                                        )
                                                    }
                                                >
                                                    {item.headline}
                                                </LinkWithIcon>
                                            </div>
                                        </Fragment>
                                    );
                                })}
                            </div>
                        </div>
                        <Box
                            pt="M300"
                            pb={index < areas.length - 1 ? 'M300' : 0}
                        >
                            <Divider direction="horizontal" />
                        </Box>
                    </Fragment>
                );
            })}
        </Fragment>
    );
};
